/**
 * Application errors are known situations which can block submission for a customer. In these cases we will show a generic error message to the customer and log the error for our own records. This is the list of known application errors which can occur during a session.
 */
const ApplicationErrors = {
  NO_MATCHES_AVAILABLE: {
    metricName: 'noMatchesAvailableError',
    logMessage:
      'Attempted to show a supplier match and there were no matches available including fallback',
    customerMessage:
      'We were unable to match you to a supplier at this time. Please try again later.',
  },
};

export default ApplicationErrors;
